import React, { useEffect, useRef, useState } from 'react';
import { useHeaderContext } from '../Context/HeaderContext';

import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import 'intl-tel-input/styles';


export default function WhatsappButton() {

  const {
    general1
  } = useHeaderContext();


  const [isBannerOpen, setIsBannerOpen] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [nombres, setNombres] = useState('');


  const phoneInputRef = useRef(null);
  const itiRef = useRef(null);


  useEffect(() => {
    let timer;

    if (isModalOpen) {
      timer = setTimeout(() => {
        if (phoneInputRef.current) {
          // Destruir instancia anterior si existía
          if (itiRef.current) {
            itiRef.current.destroy();
          }


          const intlTelInput = window.intlTelInput;
          if (typeof intlTelInput === 'function') {
            itiRef.current = intlTelInput(phoneInputRef.current, {
              initialCountry: "pe",
              countryOrder: [
                "pe", "us", "es", "cl", "mx", "co", "cr", "ec", "ar",
                "it", "gt", "de", "gb", "au", "ch", "il", "ve",
                "br", "sv", "se", "py"
              ],
              utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@24.5.0/build/js/utils.js",
              separateDialCode: true,
              autoPlaceholder: "polite",
            });
          }
        }
      }, 400);
    }

    // Limpieza al desmontar o cerrar modal
    return () => {
      if (timer) clearTimeout(timer);
      if (itiRef.current) {
        itiRef.current.destroy();
        itiRef.current = null;
      }
    };
  }, [isModalOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();


    if (itiRef.current && !itiRef.current.isValidNumber()) {
      alert("Por favor, ingresa un número válido");
      return;
    }

    const telefonoCompleto = itiRef.current ? itiRef.current.getNumber() : '';
    const currentUrl = window.location.href;
    const gclid = localStorage.getItem('gclid');
    const campaign_id = localStorage.getItem('campaign_id');

    setIsLoading(true);

    const payload = {
      nombres,
      telefono: telefonoCompleto,
      tipo_interaccion: 'whatsapp',
      url: currentUrl,
      ...(gclid ? { gclid } : {}),
      ...(campaign_id ? { campaign_id } : {})
    };

    try {
      // Petición Axios en reemplazo de $.ajax
      await axios.post('/api/contactus', payload);

      setIsSubmitted(true);

      // Cálculo de URL de WhatsApp
      let whatsappUrl = '';
      if (currentUrl.includes('producto')) {
        const productoDataRaw = localStorage.getItem('producto_actual');
        const productoData = productoDataRaw ? JSON.parse(productoDataRaw) : null;

        if (productoData) {
          const texto = `Hola, estoy interesado en este Producto:\n${productoData.nombre}\nPrecio: S/ ${productoData.precio}\nUrl: ${currentUrl}\n\nGracias!`;
          whatsappUrl = `https://api.whatsapp.com/send?phone=${general1.whatsapp}&text=${encodeURIComponent(texto)}`;
        } else {
          whatsappUrl = `https://api.whatsapp.com/send?phone=${general1.whatsapp}&text=${encodeURIComponent(general1.mensaje_whatsapp)}`;
        }
      } else {
        whatsappUrl = `https://api.whatsapp.com/send?phone=${general1.whatsapp}&text=${encodeURIComponent(general1.mensaje_whatsapp)}`;
      }

      if (whatsappUrl) {
        window.open(whatsappUrl, '_blank');
      }

      // Limpiar formulario
      setNombres('');
      if (phoneInputRef.current) {
        phoneInputRef.current.value = '';
      }

      // Cerrar modal automáticamente después de 2 segundos de éxito
      setTimeout(() => {
        closeModal();
      }, 2000);

    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      alert("Hubo un error al enviar tus datos. Por favor reintenta.");
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsSubmitted(false);
  };

  return (
    <div className="flex justify-end relative">
      {/* BOTÓN Y BANNER FLOTANTES */}
      <div className="fixed bottom-[20px] z-[10] right-[4%] md:right-[15px] fixedWhastapp flex flex-col items-end justify-end">

        {/* Banner flotante */}
        {isBannerOpen && (
          <div className="w-[250px] md:w-[267px] h-[72px] bg-[#C1DFCC] flex flex-row gap-4 absolute right-3 bottom-[124px] rounded-md p-4 shadow-lg items-center animate-pulse-slow group">
            <button
              onClick={() => setIsBannerOpen(false)}
              className="absolute -top-1 -right-1 w-6 h-6 bg-gray-400 hover:bg-gray-500 text-white rounded-full flex items-center justify-center text-xs shadow-md transition-colors"
              aria-label="Cerrar notificación"
            >
              ✕
            </button>

            <img
              src="/images/ux/IconoLD.png"
              alt="WhatsApp Icon"
              className="w-[50px] h-[50px]"
            />
            <span className="font-medium text-sm">
              Haz tu pedido ahora por WhatsApp
            </span>
          </div>
        )}

        {/* Botón de WhatsApp */}
        <div
          className="cursor-pointer absolute right-2 bottom-[60px]"
          id="btnWhatsapp"
          onClick={() => setIsModalOpen(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="50"
            height="50"
            viewBox="0 0 1219.547 1225.016"
          >
            <path
              fill="#E0E0E0"
              d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"
            />
            <defs>
              <linearGradient
                id="a"
                gradientUnits="userSpaceOnUse"
                x1="609.77"
                y1="1190.114"
                x2="609.77"
                y2="21.084"
              >
                <stop offset="0" stopColor="#20b038" />
                <stop offset="1" stopColor="#60d66a" />
              </linearGradient>
            </defs>
            <path
              fill="url(#a)"
              d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"
            />
            <image
              opacity=".08"
              width="682"
              height="639"
              transform="translate(270.984 291.372)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#FFF"
              d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"
            />
            <path
              fill="#FFF"
              d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"
            />
          </svg>
        </div>
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
          <div
            id="modalFormContactus"
            className="relative w-full max-w-[500px] p-0 rounded-t-sm shadow-2xl overflow-hidden"
          >
            {/* Botón Cerrar */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-white hover:text-gray-200 text-2xl font-bold z-10 w-8 h-8 flex items-center justify-center rounded-full bg-black/10 hover:bg-black/20 transition-colors"
            >
              ✕
            </button>

            {/* Contenido Modal */}
            <div className="bg-gradient-to-br from-gray-50 to-gray-100">
              <div className="bg-[#73B473] rounded-t-2xl px-8 py-6 shadow-lg">
                <h1 className="text-3xl font-bold text-white">Las Doñas Florería</h1>
              </div>

              <div className="bg-white rounded-b-2xl shadow-lg p-8">
                <div className="mb-6">
                  <p className="text-[20px] font-semibold text-gray-800">¡Hola! 👋</p>
                  <p className="text-gray-600 text-[16px] mt-2">
                    Escríbenos tu nombre, tu número <br /> y te contactaremos por WhatsApp 🎁💐👨🏼‍💻
                  </p>
                </div>

                {/* Mensaje de Éxito */}
                {isSubmitted && (
                  <div
                    id="successMessage"
                    className="mb-6 flex items-center gap-3 bg-green-50 border border-[#73B473] rounded-lg p-4"
                  >
                    <svg
                      className="w-6 h-6 text-[#73B473]"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <div>
                      <p className="font-semibold text-[#73B473]">¡Gracias!</p>
                      <p className="text-sm text-gray-600">Pronto nos comunicaremos</p>
                    </div>
                  </div>
                )}

                {/* Formulario */}
                <form
                  id="formContactusWhatsapp"
                  name="formContactusWhatsapp"
                  onSubmit={handleSubmit}
                  className="space-y-4"
                >
                  <input
                    type="text"
                    name="nombres"
                    id="nombres"
                    placeholder="Nombres y Apellidos"
                    required
                    value={nombres}
                    onChange={(e) => setNombres(e.target.value)}
                    className="w-full px-6 py-3 border-2 border-gray-200 rounded-full focus:outline-none focus:border-[#73B473] focus:ring-2 focus:ring-[#73B473]/20 transition-all text-gray-700 placeholder-gray-400"
                  />

                  {/* Input Teléfono montado con intlTelInput */}
                  <div className="w-full px-4 py-3 border-2 border-gray-200 rounded-full focus-within:border-[#73B473] focus-within:ring-2 focus-within:ring-[#73B473]/20 transition-all flex items-center bg-white">
                    <input
                      ref={phoneInputRef}
                      type="tel"
                      id="telefono"
                      placeholder="Teléfono"
                      required
                      className="w-full border-none p-0 focus:ring-0 text-gray-700 placeholder-gray-400 bg-transparent outline-none"
                    />
                  </div>

                  {/* Botón Submit con estado de carga */}
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="w-full bg-[#FF8555] hover:bg-[#FF7140] active:bg-[#E67335] text-white font-bold py-3 rounded-full transition-all duration-200 shadow-md hover:shadow-lg flex justify-center items-center"
                  >
                    {isLoading ? (
                      <div role="status" className="flex justify-center">
                        <svg
                          aria-hidden="true"
                          className="w-6 h-6 text-gray-200 animate-spin fill-[#FF8555]"
                          viewBox="0 0 100 101"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                          />
                          <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                          />
                        </svg>
                        <span className="sr-only">Cargando...</span>
                      </div>
                    ) : (
                      "Contactar"
                    )}
                  </button>
                </form>

                <div className="flex flex-row w-full justify-between mt-4">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 bg-[#73B473] rounded-full animate-pulse"></div>
                    <span className="text-gray-600 font-medium text-xs sm:text-sm">
                      Estamos en línea
                    </span>
                  </div>
                  <a
                    href="#politicas"
                    className="text-gray-600 hover:text-[#73B473] transition-colors text-xs sm:text-sm"
                  >
                    Políticas de privacidad
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}